import Axios from 'axios';



export default {

 
    getRpt(data){
        const BASE_URL =  '/public/api';
        return Axios.post(BASE_URL + '/reports', data);
    }

}